import { Link, useLocation, useSearchParams } from "react-router-dom";
import styled from "styled-components";

const TabBar = styled.nav`
  margin-bottom: 1.75rem;
`;

const TabList = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 0.35rem;
  padding: 0.35rem;
  background: #ececec;
  border-radius: 14px;
  border: 1px solid #e0e0e0;
  max-width: 100%;
  overflow-x: auto;

  @media (max-width: 480px) {
    display: flex;
    width: 100%;
  }
`;

const TabLink = styled(Link)`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  padding: 0.65rem 1.15rem;
  border-radius: 11px;
  font-size: 0.875rem;
  font-weight: 600;
  text-decoration: none;
  white-space: nowrap;
  color: #525252;
  background: transparent;
  border: none;
  transition: background 0.2s ease, color 0.2s ease, box-shadow 0.2s ease;

  &:hover {
    color: #383838;
    background: rgba(255, 255, 255, 0.55);
  }

  &[aria-current="page"] {
    color: #383838;
    background: #fff;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  }

  @media (max-width: 480px) {
    flex: 1;
    padding: 0.6rem 0.75rem;
    font-size: 0.8rem;
  }
`;

const CountBadge = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 1.35rem;
  height: 1.35rem;
  padding: 0 0.35rem;
  border-radius: 999px;
  font-size: 0.7rem;
  font-weight: 700;
  line-height: 1;
  background: ${(p) => (p.$active ? "var(--color-primary-soft)" : "#e5e5e5")};
  color: ${(p) => (p.$active ? "var(--color-primary)" : "#525252")};
`;

export default function InvestorInvestmentsNav({ requestCount = 0 }) {
  const { pathname } = useLocation();
  const [searchParams] = useSearchParams();
  const onRequests = pathname.startsWith("/invest/requests") && searchParams.get("filter") === "investment";

  return (
    <TabBar aria-label="Investments">
      <TabList role="tablist">
        <TabLink to="/invest/investments" role="tab" aria-current={!onRequests ? "page" : undefined}>
          Browse opportunities
        </TabLink>
        <TabLink to="/invest/requests?filter=investment" role="tab" aria-current={onRequests ? "page" : undefined}>
          My requests
          {requestCount > 0 ? (
            <CountBadge $active={onRequests} aria-label={`${requestCount} requests`}>
              {requestCount}
            </CountBadge>
          ) : null}
        </TabLink>
      </TabList>
    </TabBar>
  );
}
